import styles from './styles.module.scss';

export const Spinner = () => {
	return (
		<div className={styles.preloader}>
			<div className={styles.spinner}></div>
		</div>
	);
};
